














import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";

export default Vue.extend({

    components: {
        iwInputGroupStepper: iwInputGroupStepper
    },
    data: function() {
        return {
            pathInStore: "property.livingDescription.fireplace.count",
        };
    },
    computed: {
        fireplaceCount: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        hasFireplace: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("property.hasFireplace");
        }
    },
    methods: {
        updateValue: function(fireplaceCount: number): void {
            if (!this.hasFireplace || (fireplaceCount == 0 && this.fireplaceCount != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": fireplaceCount});
            }
        }
    }
});

